import { render, staticRenderFns } from "./CadastroCotacaoProdutosTable.vue?vue&type=template&id=e1f6ac4a&scoped=true&"
import script from "./CadastroCotacaoProdutosTable.vue?vue&type=script&lang=js&"
export * from "./CadastroCotacaoProdutosTable.vue?vue&type=script&lang=js&"
import style0 from "./CadastroCotacaoProdutosTable.vue?vue&type=style&index=0&id=e1f6ac4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1f6ac4a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCol,VIcon,VRow,VSimpleTable})
